export default {
  form: {
    amount: {
      label: 'Hinta',
    },
    threshold: {
      label: 'Kuukausimyynti',
    },
    has_pricing_tiers: {
      label: 'Hinta muuttuu kuukausimyynnin mukaan',
    },
    tax_included: {
      label: 'Sisältää veron',
    },
  },
  buttons: {
    add_tier: 'Lisää taso',
  },
};
